import { FlatTreeControl } from '@angular/cdk/tree';
import { Injectable } from '@angular/core';
import { TreeNode } from '@app/features/hierarchy/models/hierarchy.model';
import { HierarchyService } from '@app/features/hierarchy/services/hierarchy.service';
import { TreeViewDataSource } from '../../widgets/hierarchy-select-node/node-tree-view.datasource';
import { TreeService } from './node-tree-abstract.service';

@Injectable()
export class ViewTreeService extends TreeService<TreeViewDataSource> {
  constructor(private hierarchyService: HierarchyService) {
    super();
  }

  public initialize() {
    this.treeControl = new FlatTreeControl<TreeNode>(this.getLevel, this.isExpandable);
    this.dataSource = new TreeViewDataSource(this.treeControl, this.hierarchyService);
    this.dataSource$.next(this.dataSource);
  }
}
